import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import OrderBy from './OrderBy';
import StorageService from 'services/StorageService';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const ShelfHeader = (props) => {

    const {title, quantity, searchWord} = props;
    const [orderText, setOrderText] = useState('Ordenar por');
    let attemptsSearch = StorageService.getItem('attemptsSearch')

    useEffect(() => {


        if(attemptsSearch){
            TagManagerService.interaction( searchWord, title, 'Search Autocorrections');
        }
    }, []);

    const openFilter = () => {
        window.scroll({
            top: window.scrollY + 1,
            behavior: 'smooth'
        });
        PubSub.dispatch('catalog_toogleFilter', { isFilterOpened: true});
    }

    const openFilterOrder = () => {
        PubSub.dispatch('catalog_toogleFilter', { isOrderOpened: true});
    }

    const orderBy = (text) => {
        setOrderText(text);
    }


    return (
        <div className={'shelf-header'}>
            {attemptsSearch && searchWord && <span className="shelf-header-terms">No encontramos resultados para <strong>{`"${searchWord}"`}</strong> te sugerimos estos productos:</span>}
            <div className="shelf-header-title-wrapper">
                <span className="shelf-header-title-wrapper-left">
                    {title && <h2 className="shelf-header-title">{title}</h2>}
                    {!!quantity && <span className="shelf-header-amount">{quantity} productos</span>}
                </span>
                <OrderBy order={props.order} orderBy={orderBy} title={title} filter={props.filter}/>
            </div>
            <div className="shelf-header-options">
                <button className="shelf-filter-mobile-btn" onClick={openFilter}>
                    <i className="font-icn filter"/>
                    Filtrar
                </button>
                <div className="shelf-header-order-by-label" onClick={openFilterOrder}>
                    <i className="order-icon-mobile jumbo-icon-replacement"> </i>
                    <span className="shelf-header-span">{orderText}</span>
                </div>
            </div>
        </div>
    )
}
ShelfHeader.propTypes = {
    order: PropTypes.string,
    quantity: PropTypes.number,
    title: PropTypes.string,
    filters: PropTypes.object,
    specifications: PropTypes.array,
    filter: PropTypes.object,
    searchWord : PropTypes.string
}
export default ShelfHeader;
